import React, { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

const DatePicker = () => {
  // State to keep track of selected dates
  const [selectedDates, setSelectedDates] = useState([]);

  // Handle date selection
  const handleDateChange = (date) => {
    if (selectedDates.some((selectedDate) => selectedDate.toDateString() === date.toDateString())) {
      // If the date is already selected, remove it
      setSelectedDates(selectedDates.filter((selectedDate) => selectedDate.toDateString() !== date.toDateString()));
    } else {
      // Otherwise, add the date
      setSelectedDates([...selectedDates, date]);
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg">
      <h2 className="text-lg font-semibold mb-4">Dispatch Schedule</h2>
      <DayPicker
        selected={selectedDates}
        onDayClick={handleDateChange}
        mode="multiple"
        className="border border-gray-300 rounded-lg p-2"
      />
      {/* <div className="mt-4">
        <h3 className="font-medium">Selected Dates:</h3>
        <ul>
          {selectedDates.map((date, index) => (
            <li key={index} className="text-sm text-gray-700">
              {date.toLocaleDateString()}
            </li>
          ))}
        </ul>
      </div> */}
    </div>
  );
};

export default DatePicker;
